export default __webpack_public_path__ + "static/media/edusearch.257c021c.svg";